function Header() {
  return (
    <section className="navbars" id="header">
      <header className="site-header">
        <nav className="l-contain l-contain--flush l-grid l-grid--flush | site-header__nav">
          <a className="site-header__title" href="#main">
            <span className="site-header__title-decor"></span>
            <span className="site-header__title-text">
              Ayomide&nbsp;Alajogun
            </span>
          </a>

          <ul className="u-simple-list site-header__list">
            <li>
              <a href="#product">
                <span>Projects</span>
              </a>
            </li>
            <li>
              <a href="#nuggets">
                <span>Product Nuggets</span>
              </a>
            </li>

            <li>
              <a href="#info">
                <span>Info</span>
              </a>
            </li>
          </ul>
        </nav>
      </header>
    </section>
  );
}

export default Header;
